// extracted by mini-css-extract-plugin
export default {"ScrollIndicator":"Messages_ScrollIndicator__YaxUL","slideIn":"Messages_slideIn__YRbUj"};